import React, { useReducer } from "react";

export const initialWizardFormState = {
  masterGraduationDate: "",
  // bachelorGraduationDate:"",
  // htlGraduationDate:"",
  single: {
    personalInfo: {
      gender: "",
      firstName: "",
      lastName: "",
      nationality: "",
      dateOfBirth: "",
      language: null,
      diplomTitle: "",
      academicTitle: null,
      additionalInfo: "",
      street: "",
      zip: "",
      city: "",
      country: null,
      canton: null,
      phone: "",
      mobile: "",
      email: "",
    },
    workplaceInfo: {
      hasWorkplace: false,
      currentAddress: null,
      companyName: "",
      department: "",
      street: "",
      zip: "",
      city: "",
      country: null,
      canton: null,
      phone: "",
      mobile: "",
      email: "",
      since: "",
      profession: null,
      jobFunction: null,
      branch: null,
      activities: null,
    },
    otherAddressesInfo: {
      contact: null,
      delivery: null,
      invoice: null,
    },
    educationInfo: {
      schoolName: null,
      studyType: null,
      graduationDate: "",
      diplomTitle: "",
      diplomFile: null,
      referencesFile: null,
      masterSchoolName: null,
      masterStudyType: null,
      masterGraduationDate: "",
      masterTitle: "",
      masterFile: null,
      doctorateSchoolName: null,
      doctorateStudyType: null,
      doctorateGaduationDate: "",
      doctorateTitle: "",
      doctorateFile: null,
    },
    sectionInfo: {
      section: null,
      professionalGroup: null,
    },
    communicationInfo: {
      selectedMagazine: "",
      magazineFormatEpaper: false,
      magazineFormatPrinted: false,
      newsLetterGerman: false,
      newsLetterFrench: false,
      siaInformNewsletterDe: false,
      siaInformNewsletterFr: false,
      siaInformNewsletterIt: false,
    },
  },
  student: {
    personalInfo: {
      gender: "",
      firstName: "",
      lastName: "",
      nationality: "",
      dateOfBirth: "",
      language: null,
      additionalInfo: "",
      street: "",
      zip: "",
      city: "",
      country: null,
      canton: null,
      phone: "",
      mobile: "",
      email: "",
      schoolName: null,
      studyType: null,
      studyStart: "",
      studyEnd: "",
      proofOfEnrollmentFile: null,
    },
    sectionInfo: {
      section: null,
      professionalGroup: null,
    },
    communicationInfo: {
      selectedMagazine: "",
      magazineFormatEpaper: false,
      magazineFormatPrinted: false,
      newsLetterGerman: false,
      newsLetterFrench: false,
      siaInformNewsletterDe: false,
      siaInformNewsletterFr: false,
      siaInformNewsletterIt: false,
    },
  },
  corporate: {
    singleMember: {
      siaId: "",
      firstname: "",
      lastname: "",
    },
    corporateInfo: {
      name: "",
      extraName: "",
      foundingDate: "",
      language: null,
      uid: "",
      website: "",
      branch: null,
      specialites: null,
    },
    mainAddress: {
      street: "",
      streetTwo: "",
      zip: "",
      city: "",
      country: null,
      canton: null,
      phone: "",
      email: "",
    },
    ahv: {
      year: "",
      sum: "",
      ahvFile: null,
      numberOfEmployees: "",
    },
    communicationInfo: {
      selectedMagazine: "",
      magazineFormatEpaper: false,
      magazineFormatPrinted: false,
      newsLetterGerman: false,
      newsLetterFrench: false,
      siaInformNewsletterDe: false,
      siaInformNewsletterFr: false,
      siaInformNewsletterIt: false,
    },
  },
};

const MASTER_GRADUATION_CHANGED_ACTION = "MASTER_GRADUATION_CHANGED_ACTION";
export const masterGraduationDateCreator = (payload) => ({ type: MASTER_GRADUATION_CHANGED_ACTION, payload });

// single member registration action creators
const SINGLE_PERSONAL_INFO_CHANGED_ACTION = "SINGLE_PERSONAL_INFO_CHANGED_ACTION";
export const singlePersonalInfoActionCreator = (payload) => ({ type: SINGLE_PERSONAL_INFO_CHANGED_ACTION, payload });

const SINGLE_WORKPLACE_INFO_CHANGED_ACTION = "SINGLE_WORKPLACE_INFO_CHANGED_ACTION";
export const singleWorkPlaceInfoActionCreator = (payload) => ({ type: SINGLE_WORKPLACE_INFO_CHANGED_ACTION, payload });

const SINGLE_OTHER_ADDRESSES_INFO_CHANGED_ACTION = "SINGLE_OTHER_ADDRESSES_INFO_CHANGED_ACTION";
export const singleOtherAddressesInfoActionCreator = (payload) => ({ type: SINGLE_OTHER_ADDRESSES_INFO_CHANGED_ACTION, payload });

const SINGLE_EDUCATION_INFO_CHANGED_ACTION = "SINGLE_EDUCATION_INFO_CHANGED_ACTION";
export const singleEducationInfoActionCreator = (payload) => ({ type: SINGLE_EDUCATION_INFO_CHANGED_ACTION, payload });

const SINGLE_SECTION_INFO_CHANGED_ACTION = "SINGLE_SECTION_INFO_CHANGED_ACTION";
export const singleSectionInfoActionCreator = (payload) => ({ type: SINGLE_SECTION_INFO_CHANGED_ACTION, payload });

const SINGLE_COMMUNICATION_INFO_CHANGED_ACTION = "SINGLE_COMMUNICATION_INFO_CHANGED_ACTION";
export const singleCommunicationInfoActionCreator = (payload) => ({ type: SINGLE_COMMUNICATION_INFO_CHANGED_ACTION, payload });

// student member registration action creators
const STUDENT_PERSONAL_INFO_CHANGED_ACTION = "STUDENT_PERSONAL_INFO_CHANGED_ACTION";
export const studentPersonalInfoActionCreator = (payload) => ({ type: STUDENT_PERSONAL_INFO_CHANGED_ACTION, payload });

const STUDENT_SECTION_INFO_CHANGED_ACTION = "STUDENT_SECTION_INFO_CHANGED_ACTION";
export const studentSectionInfoActionCreator = (payload) => ({ type: STUDENT_SECTION_INFO_CHANGED_ACTION, payload });

const STUDENT_COMMUNICATION_INFO_CHANGED_ACTION = "STUDENT_COMMUNICATION_INFO_CHANGED_ACTION";
export const studentCommunicationInfoActionCreator = (payload) => ({ type: STUDENT_COMMUNICATION_INFO_CHANGED_ACTION, payload });

// corporate memeber registration action creators
const CORPORATE_SINGLE_MEMBERS_CHANGED_ACTION = "CORPORATE_SINGLE_MEMBERS_CHANGED_ACTION";
export const corporateSingleMembersActionCreator = (payload) => ({ type: CORPORATE_SINGLE_MEMBERS_CHANGED_ACTION, payload });

const CORPORATE_INFO_CHANGED_ACTION = "CORPORATE_INFO_CHANGED_ACTION";
export const corporateInfoActionCreator = (payload) => ({ type: CORPORATE_INFO_CHANGED_ACTION, payload });

const CORPORATE_MAIN_ADDRESS_CHANGED_ACTION = "CORPORATE_MAIN_ADDRESS_CHANGED_ACTION";
export const corporateMainAddressActionCreator = (payload) => ({ type: CORPORATE_MAIN_ADDRESS_CHANGED_ACTION, payload });

const CORPORATE_AHV_CHANGED_ACTION = "CORPORATE_AHV_CHANGED_ACTION";
export const corporateAhvActionCreator = (payload) => ({ type: CORPORATE_AHV_CHANGED_ACTION, payload });

const CORPORATE_COMMINCATION_INFO_CHANGE_ACTION = "CORPORATE_COUMMINCATION_INFO_CHANGE_ACTION";
export const corporateCommunicationInfoActionCreator = (payload) => ({ type: CORPORATE_COMMINCATION_INFO_CHANGE_ACTION, payload });

const reducer = (state, action) => {
  switch (action.type) {
    case MASTER_GRADUATION_CHANGED_ACTION:
      return { ...state, masterGraduationDate: action.payload.masterGraduationDate };
    // single member slices
    case SINGLE_PERSONAL_INFO_CHANGED_ACTION:
      return { ...state, single: { ...state.single, personalInfo: { ...state.single.personalInfo, ...action.payload } } };

    case SINGLE_WORKPLACE_INFO_CHANGED_ACTION:
      return { ...state, single: { ...state.single, workplaceInfo: { ...state.single.workplaceInfo, ...action.payload } } };

    case SINGLE_OTHER_ADDRESSES_INFO_CHANGED_ACTION:
      return { ...state, single: { ...state.single, otherAddressesInfo: { ...state.single.otherAddressesInfo, ...action.payload } } };

    case SINGLE_EDUCATION_INFO_CHANGED_ACTION:
      return { ...state, single: { ...state.single, educationInfo: { ...state.single.educationInfo, ...action.payload } } };

    case SINGLE_SECTION_INFO_CHANGED_ACTION:
      return { ...state, single: { ...state.single, sectionInfo: { ...state.single.sectionInfo, ...action.payload } } };

    case SINGLE_COMMUNICATION_INFO_CHANGED_ACTION:
      return { ...state, single: { ...state.single, communicationInfo: { ...state.single.communicationInfo, ...action.payload } } };

    // student member slices
    case STUDENT_PERSONAL_INFO_CHANGED_ACTION:
      return { ...state, student: { ...state.student, personalInfo: { ...state.student.personalInfo, ...action.payload } } };

    case STUDENT_SECTION_INFO_CHANGED_ACTION:
      return { ...state, student: { ...state.student, sectionInfo: { ...state.student.sectionInfo, ...action.payload } } };

    case STUDENT_COMMUNICATION_INFO_CHANGED_ACTION:
      return { ...state, student: { ...state.student, communicationInfo: { ...state.student.communicationInfo, ...action.payload } } };

    // corporate member slices
    case CORPORATE_SINGLE_MEMBERS_CHANGED_ACTION:
      return { ...state, corporate: { ...state.corporate, singleMember: { ...state.corporate.singleMember, ...action.payload } } };

    case CORPORATE_INFO_CHANGED_ACTION:
      return { ...state, corporate: { ...state.corporate, corporateInfo: { ...state.corporate.corporateInfo, ...action.payload } } };

    case CORPORATE_MAIN_ADDRESS_CHANGED_ACTION:
      return { ...state, corporate: { ...state.corporate, mainAddress: { ...state.corporate.mainAddress, ...action.payload } } };

    case CORPORATE_AHV_CHANGED_ACTION:
      return { ...state, corporate: { ...state.corporate, ahv: { ...state.corporate.ahv, ...action.payload } } };

    case CORPORATE_COMMINCATION_INFO_CHANGE_ACTION:
      return { ...state, corporate: { ...state.corporate, communicationInfo: { ...state.corporate.communicationInfo, ...action.payload } } };

    default:
      return state;
  }
};

export const WizarContext = React.createContext({ state: {}, dispatch: () => null });

const WizardProvider = (props) => {
  const [state, dispatch] = useReducer(reducer, initialWizardFormState);
  return <WizarContext.Provider value={{ state, dispatch }}>{props.children}</WizarContext.Provider>;
};

export default WizardProvider;
